import React, {useState} from "react";
import { useParams } from "react-router-dom";
import "../styles/ProjectDetails-style.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink} from "@fortawesome/free-solid-svg-icons";

const ProjectDetails = ({ projects }) => {
    const { title } = useParams();
    const project = projects.find((project) => project.title === title);

    const [selectedImage, setSelectedImage] = useState(null);

    if (!project) {
        return <div>Project not found</div>;
    }

    const { title: projectTitle, date, content, images } = project;

    return (
        <div className="project-details">
            <div className="project-header">
                <div className={"back-home"}>
                    <a href={"/"}>
                    <svg xmlns="http://www.w3.org/2000/svg" stroke-width="2" width="24" height="24"
                         stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" fill="none"
                         viewBox="0 0 24 24" className="inline-block w-4 h-4 mr-2">
                        <path d="m12 19-7-7 7-7"></path>
                        <path d="M19 12H5"></path>
                    </svg>
                        Back to home</a>
                </div>
            <h1>{projectTitle}</h1>

            <div className={"author"}>
                <p className={"author-date"}>{date}</p>
                <p className={"author-label"}>Written by</p>
                <div className={"author-info"}>
                        <img
                            src={require("../images/moi.png")}
                            alt={"Author"}
                            className={"author-image"}
                        />
                        <p>Rémy Kinzelin</p>

                    </div>
                </div>
            </div>
            <hr/>
            <div className="project-content">
                {content}

                {project.link && (
                    <a className={"project-link-container"} href={project.link || "#"} target="_blank"
                       rel="noopener noreferrer"><FontAwesomeIcon icon={faLink}/>View project</a>
                )}

            </div>
            <div className="image-gallery">
                {images.map((image, index) => (
                    <img
                        key={index}
                        src={image}
                        alt={`Image ${index + 1}`}
                        className="gallery-image"
                        onClick={() => setSelectedImage(image)}
                    />
                ))}
            </div>
            {selectedImage && (
                <div className={`popup ${selectedImage ? 'active' : ''}`} onClick={() => setSelectedImage(null)}>
                    <div className={`popup-inner ${selectedImage ? 'active' : ''}`}>
            <span className="close" onClick={() => setSelectedImage(null)}>
                &times;
            </span>
                        <img src={selectedImage} alt="Selected" className="popup-image" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjectDetails;
